import { render, staticRenderFns } from "./join_4.vue?vue&type=template&id=b541cad0&scoped=true"
import script from "./join_4.vue?vue&type=script&lang=js"
export * from "./join_4.vue?vue&type=script&lang=js"
import style0 from "./join_4.vue?vue&type=style&index=0&id=b541cad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b541cad0",
  null
  
)

export default component.exports